<template>
  <div v-if="currentNoteFrais">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date</span>
                  </td>
                  <td>
                    {{ currentNoteFrais.date }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Centre de coût</span>
                  </td>
                  <td>
                    {{ currentNoteFrais.centre_cout.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Devise</span>
                  </td>
                  <td>
                    {{
                      currentNoteFrais.devise.symbole +
                      ' ( ' +
                      currentNoteFrais.devise.nom +
                      ' )'
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentNoteFrais.created_by.prenom
                        ? currentNoteFrais.created_by.prenom +
                          ' ' +
                          currentNoteFrais.created_by.nom
                        : currentNoteFrais.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Libellé</span>
                  </td>
                  <td>
                    {{ currentNoteFrais.libelle }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> N° note de frais</span>
                  </td>
                  <td>
                    {{ currentNoteFrais.num_facture }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Taux de change</span>
                  </td>
                  <td>
                    {{ currentNoteFrais.taux }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Employé</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentNoteFrais.employe.prenom
                        ? currentNoteFrais.employe.prenom +
                          ' ' +
                          currentNoteFrais.employe.nom
                        : currentNoteFrais.employe.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col-md-12">
          <table class="card table table-sm">
            <thead>
              <tr class="d-flex">
                <th class="col-3">Désignation</th>
                <th class="col-3">Type de note de frais</th>
                <th class="col-2 text-center">Quantité</th>
                <th class="col-1 text-center">Prix HT</th>
                <th class="col-1 text-center">TVA %</th>
                <th class="col-2 text-center">Montant</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in currentNoteFrais.item_lists"
                :key="index"
                class="d-flex"
              >
                <td class="col-3" style="vertical-align: middle">
                  {{ item.designation }}
                </td>
                <td class="col-3" style="vertical-align: middle">
                  {{ item.note_frais_type.nom }}
                </td>

                <td class="col-2 text-center" style="vertical-align: middle">
                  {{ item.quantite }}
                </td>
                <td class="col-1 text-center" style="vertical-align: middle">
                  {{ item.prix }}
                </td>
                <td class="col-1 text-center" style="vertical-align: middle">
                  {{ item.tva + '%' }}
                </td>

                <td
                  class="col-2 text-right font-weight-bold font-size-17"
                  style="vertical-align: middle"
                >
                  {{
                    formatWithCurrency(
                      item.quantite * item.prix +
                        (item.tva / 100) * (item.quantite * item.prix),
                      currentNoteFrais.devise.symbole
                    )
                  }}
                </td>
              </tr>
              <tr
                v-if="currentNoteFrais.item_lists.length === 0"
                class="d-flex"
              >
                <td class="text-center col-12">Pas de données</td>
              </tr>
            </tbody>
            <tfoot class="font-weight-bold font-size-18">
              <tr class="d-flex">
                <td class="text-right col-8">TOTAL HT</td>
                <td class="text-right col-4">
                  {{
                    formatWithCurrency(totalHt, currentNoteFrais.devise.symbole)
                  }}
                </td>
              </tr>
              <tr class="d-flex" v-if="totalTva > 0">
                <td class="text-right col-8">TOTAL TVA</td>
                <td class="text-right col-4">
                  {{
                    formatWithCurrency(
                      totalTva,
                      currentNoteFrais.devise.symbole
                    )
                  }}
                </td>
              </tr>
              <tr class="d-flex" v-if="totalTva > 0">
                <td class="text-right col-8">TOTAL TTC</td>
                <td class="text-right col-4">
                  {{
                    formatWithCurrency(
                      totalHt + totalTva,
                      currentNoteFrais.devise.symbole
                    )
                  }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters('noteFrais', ['currentNoteFrais']),
    totalHt() {
      return window._.sumBy(
        this.currentNoteFrais.item_lists,
        (item) => item.quantite * item.prix
      );
    },
    totalTva() {
      return window._.sumBy(
        this.currentNoteFrais.item_lists,
        (item) => (item.tva / 100) * (item.quantite * item.prix)
      );
    },
  },
  methods: {
    ...mapActions('noteFrais', ['getNoteFrais']),
    init() {
      this.getNoteFrais(this.$route.params.id);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.table td {
  vertical-align: middle;
  font-size: 16px;
}
</style>
